import { Component, Inject, Input, EventEmitter, Output, ViewChild } from '@angular/core';

import { Subject, combineLatest } from 'rxjs';

import { MultiFilterableSelectComponent } from '../../../../shared/filterable-select/components/multi-filterable-select.component';

import { AgenceService } from '../services/agence.service';
import { AgenceTLR } from '../entities/agence-tlr.entity';

@Component({
	selector: 'agence-filterable-selector',
	templateUrl: 'agence-filterable-selector.html',
})
export class AgenceFilterableSelectorComponent {
	agences: AgenceTLR[] = [];
	selectedAgence: AgenceTLR | undefined = undefined;

	getAgenceLabel = (agence: AgenceTLR) => agence.nom;
	
	selectedAgenceIdSubject = new Subject<number | null>();

	constructor( //
		@Inject(AgenceService) agenceService: AgenceService //
	) {
		let agences$ = agenceService.getAgenceTLRList();
		agences$.subscribe(
			(agences : AgenceTLR[]) => {
				this.agences = agences;
			}
		);
		
		// Definit comment combiner les donnees sur l'ensemble des agences connues avec un id d'agence pour fixer l'agence actuellement selectionnee 
		combineLatest([agences$, this.selectedAgenceIdSubject]).subscribe(
			data => {
				let agences = data[0];
				let agenceId = data[1];
				
				if (agenceId) {
					let agence = agences.find(agence => agence.id === agenceId);
					if (!agence) {
						throw new Error("Unknown agence #" + agenceId);
					}
					
					this.selectedAgence = agence;
				} else {
					this.selectedAgence = undefined;
				}
			}
		);
	}

	@ViewChild(MultiFilterableSelectComponent) input!: MultiFilterableSelectComponent;

	@Input() id!: string;
	@Input() disabled = false;
	
	// Classes pour l'affichege
	public _labelClass: string = 'col-md-1';
	@Input() set labelClass(value: string | undefined) {
		if (value) {
			this._labelClass = value;
		}	
	}
	get labelClass(): string | undefined {
		return this._labelClass;
	}
	
	public _fieldClass: string = 'col-md-7';
	@Input() set fieldClass(value: string | undefined) {
		if (value) {
			this._fieldClass = value;
		}
	}
	get fieldClass(): string | undefined {
		return this._fieldClass;
	}
	
	private _selectedAgenceId: number | null | undefined = null;
	@Input() set selectedAgenceId(id: number | null | undefined) {
		this._selectedAgenceId = id;
		this.selectedAgenceIdSubject.next(id);
	}
	get selectedAgenceId(): number | null | undefined {
		return this._selectedAgenceId;
	}
	
	@Output() selectedAgenceIdChange = new EventEmitter<number | null>();
	
	@Output() selectedAgenceChange = new EventEmitter<AgenceTLR | null>();
	
	onSelectedAgenceChange(agence: AgenceTLR | null) {
		let id = agence ? agence.id : null;
		this._selectedAgenceId = id;
		this.selectedAgenceIdChange.emit(id);
		this.selectedAgenceChange.emit(agence);
	}
}